module.exports = __webpack_public_path__ + "img/media (12).32a60314.png";